module.exports = __webpack_public_path__ + "static/media/promotion_from_40_to_44.46b0f9a9.webp";